import gql from 'graphql-tag';

export const DeleteLostAndFoundIssueDocument = gql`
  mutation DeleteLostAndFoundIssueDocumentBulk($input: DeleteLostAndFoundIssueDocumentBulkInput!) {
    deleteLostAndFoundIssueDocumentBulk(input: $input) {
      deleted
    }
  }
`;
